<template>
  <div class="contenedor-mapa" :id="id">
   
  </div>
</template>

<script>
import * as d3 from 'd3';
import * as L from 'leaflet';
import "@/../node_modules/leaflet.tilelayer.colorfilter/src/leaflet-tilelayer-colorfilter.js"
export default {
  name: 'PortadaMapa',
  props:{
    paso_inicial:{
      type:Number,
      default:1
    },
    direccion:String,
    id:String
  },
  watch:{
    paso_inicial:function(new_val){
      console.log(new_val)
      this.svg_mapa=d3.select("div#"+this.id).select("div.leaflet-pane.leaflet-overlay-pane svg");
      if(new_val == 1){
        this.paso_general("antiguo_lago");
        this.paso_1();
      }
      if(new_val == 2){
        this.paso_general("antiguo_lago");
        this.paso_2();
      }
      else if(new_val == 3){
        this.paso_general("antiguo_lago");
        this.paso_3();
      }
      else if(new_val == 4){
        this.paso_general("zona_naicm");
        this.paso_4();
      }
      else if(new_val == 5){
        this.paso_general("zona_federal");
        this.paso_5();
      }
      else if(new_val == 6){
        this.paso_general("subcuenca");
        this.paso_6();
      }
      /*else if(new_val == 7){
        this.paso_general("subcuenca");
        this.paso_7();
        this.layers["capa_estatal"].setStyle((feature)=>{
              return {...this.estilo_pols_estatales,weight:1,opacity:.6}
          })
      }*/
      else if(new_val == 7){
        if(window.innerWidth>1500){
          this.bounds_comparacion_final=L.latLngBounds(
            L.latLng(20.6, -102.8),
            L.latLng(17.6, -99.8)
          );
        }
        else if (window.innerWidth<1500 && window.innerWidth>900){
          this.bounds_comparacion_final=L.latLngBounds(
            L.latLng(21, -103.8),
            L.latLng(16, -98.8)
          );

        }
        
        else{
          this.bounds_comparacion_final=L.latLngBounds(
            L.latLng(23, -105.5),
            L.latLng(15, -97.5)
          );
        }
        this.mapa.flyToBounds(this.bounds_comparacion_final,this.fit_option);
        this.layers["capa_estatal"].setStyle((feature)=>{
              return {...this.estilo_pols_estatales,weight:feature.properties.cvegeo=="06"?3:1,opacity:feature.properties.cvegeo=="06"?1:.6,fillOpacity:feature.properties.cvegeo=="06"?.4:.0}
          })
        this.svg_mapa.select("path.subcuenca")
          .attr("stroke","#F2E205")

      }
      
      if(new_val>=8){
        d3.select("#"+this.id)
          .transition()
          .duration(500)
          .style("opacity",0)
      }
      else{
        d3.select("#"+this.id)

          .style("opacity",1)
      }
      
    },
  },
  data(){
    return {
      estilo_pols:{"color": "#fff","weight": 3,"fillOpacity":0,"opacity":.4},
      estilo_apagado:{"color": "none","weight": 1,"fillOpacity":0,"fillColor":"#F7F7F7"},
      estilo_pols_estatales:{"color": "#fff","weight": 1,"fillOpacity":0,"opacity":.6},
      layers:[],
      nombre_layers:["ex_aicm","zona_naicm","zona_federal","subcuenca","antiguo_lago","actual_lago"],
      estilo_layers_on:{
        "actual_lago": {'className': 'actual_lago',"color": "#05DBF2","weight": 3,"fillOpacity":.0,"opacity":1,fillColor:"#05DBF2"},
        "antiguo_lago": {'className': 'antiguo_lago',"color": "#fff","weight": 3,"fillOpacity":.2,"opacity":1,fillColor:"#fff"},
        "ex_aicm":{'className': 'ex_aicm',"color": "#000","weight": 3,"fillOpacity":0,"opacity":0,fillColor:"#000"}, //La X
        "zona_naicm":{'className': 'zona_naicm',"color": "#000","weight": 3,"fillOpacity":.0,"opacity":1,fillColor:"#FDF5AB"},//Zona del aeropuerto
        "zona_federal":{'className': 'zona_federal',"color": "#000","weight": 3,"fillOpacity":0,"opacity":1,fillColor:"#FCF057"},// Zona federal
        "subcuenca":{'className': 'subcuenca',"color": "#000","weight": 3,"fillOpacity":0,"opacity":1,fillColor:"#F4DF00"}
      },
      bounds_comparacion_final:L.latLngBounds(
        L.latLng(23, -105.5),
        L.latLng(15, -97.5)
      ),
      duracion_transiciones:1,
      bounds_antiguo_lago:L.latLngBounds(
        L.latLng(19.51234721425757, -98.99445116832928),
        L.latLng(19.48796460974024, -99.00022646832086)
      ),
      
      fit_option:{ paddingTopLeft: [0, 50], paddingBottomRight:[ 0,0],duration:1}
    }
  },
  mounted() {
    this.fit_option={ paddingTopLeft: [0, 100], paddingBottomRight:[ 0,0],duration:this.duracion_transiciones } 

    this.mapa = L.map(this.id,{zoomControl:false,scrollWheelZoom:false,zoomSnap:.25})
      let myFilter = ["grayscale:100%","bright:109%","contrast:144%","saturate:84%"];
     let tileLayer = L.tileLayer.colorFilter(
       'https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWlndWVsLWFuZ2VsLW1hcnRpbmV6IiwiYSI6ImNrdXpzZWVqazdmMWsyd256MW0zZGRhNm4ifQ.bwGG86eamN63Cg75k7A4RQ',{
        //'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        filter:myFilter,

        keepBuffer:4,
	      attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>'  
    }).addTo(this.mapa);
    tileLayer.on("load",function(){
      //AQUI SE QUITA EL LOADER , SOLO SI EXISTE
      if(document.getElementById("initial-loader")){
        document.getElementById("initial-loader").remove()
        document.getElementsByTagName("body")[0].style.overflow = 'visible'
      }
      
    })
  
    
    
    d3.json("data/capa_estatal.geojson")
      .then((capa_estatal)=>{
        this.capa_estatal=capa_estatal;
        this.layers["capa_estatal"]=L.geoJSON(this.capa_estatal,{
          style:this.estilo_pols_estatales,
        })
        .addTo(this.mapa) 
        //Agregando subcuenca
        d3.json("data/region_nororiente_cuenca_mexico.geojson")
          .then((subcuenca)=>{
            this.subcuenca=subcuenca;
            this.layers["subcuenca"]=L.geoJSON(this.subcuenca,{
              style:this.estilo_layers_on["subcuenca"],
            }).addTo(this.mapa)
      
          //Agregando zona federal      
          d3.json("data/zona_federal_32614.geojson")
            .then((zona_federal)=>{
              this.zona_federal=zona_federal;
              this.layers["zona_federal"]=L.geoJSON(this.zona_federal,{
                  style:this.estilo_layers_on["zona_federal"],
              })
              .addTo(this.mapa)
            // Agregando zona naicm
            d3.json("data/zona_naicm.geojson")
              .then((zona_naicm)=>{
                this.zona_naicm=zona_naicm;
                this.layers["zona_naicm"]=L.geoJSON(this.zona_naicm,{
                  style:this.estilo_layers_on["zona_naicm"],
                }).addTo(this.mapa).addTo(this.mapa)
              //Agregando X
              d3.json("data/ex_aicm_x_32614.geojson")
                  .then((ex_aicm)=>{
                    this.ex_aicm=ex_aicm;
                    this.layers["ex_aicm"]=L.geoJSON(this.ex_aicm,{
                      style:this.estilo_layers_on["ex_aicm"],
                    })
                    .addTo(this.mapa)
                //Agregando antiguo lago
                d3.json("data/antiguo_lago_texcoco.geojson")
                    .then((antiguo_lago)=>{
                      this.antiguo_lago=antiguo_lago;
                      this.layers["antiguo_lago"]=L.geoJSON(this.antiguo_lago,{
                        style:this.estilo_layers_on["antiguo_lago"],
                      })
                      .addTo(this.mapa)
                    
                  this.bounds_antiguo_lago = Object.values(this.layers["antiguo_lago"]._layers)[0]._bounds;
                  this.mapa.fitBounds(this.bounds_antiguo_lago)
                  //Agregando antiguo lago
                  d3.json("data/cuerpos_agua_portada.geojson")
                      .then((actual_lago)=>{
                        this.actual_lago=actual_lago;
                        this.layers["actual_lago"]=L.geoJSON(this.actual_lago,{
                          style:this.estilo_layers_on["actual_lago"],
                        })
                      .addTo(this.mapa)
                    setTimeout(()=>{
                      this.svg_mapa=d3.select("div#"+this.id).select("div.leaflet-pane.leaflet-overlay-pane svg");
                      this.paso_1();
                    },100)
                  })
                })
              })
              
            })
          })    
        })
      })
  },
  methods: {
    agregar_defs(){
      this.svg_mapa=d3.select("div#"+this.id).select("div.leaflet-pane.leaflet-overlay-pane svg");
      this.defs_mapa=this.svg_mapa.insert("defs",":first-child")
            .attr("id","defs-mapa")

      let pattern=this.defs_mapa.append("pattern").attr("id","zona_naicm")
            .attr("x", "0")
            .attr("y", "0")
            .attr("width", "8")
            .attr("height", "8")
            .attr("patternUnits", "userSpaceOnUse")
            .attr("patternContentUnits", "userSpaceOnUse")
            .attr("patternTransform", `rotate(${45})`);
        pattern
          .append("path")
          .attr("stroke", "#fff")
          .attr("stroke-width", "4")
          .attr("d", "M0 2 H 8 ");

    },
    apagar_poligonos(clave_layer){
      let is_clave_actual=false;
      for (let i=0;i<this.nombre_layers.length;i++){
        this.layers[this.nombre_layers[i]].eachLayer((layer)=>{
         // layer.setStyle(!is_clave_actual?this.estilo_apagado:this.estilo_layers_on[this.nombre_layers[i]])
        }) 
        if(clave_layer==this.nombre_layers[i])is_clave_actual=true;

      }
    },
    paso_general(clave_layer){
      if("ex_aicm"==clave_layer){
        this.mapa.flyToBounds(this.bounds_antiguo_lago,this.fit_option);
      }else{
        this.mapa.flyToBounds(this.layers[clave_layer],this.fit_option);
      }
    },
    paso_1(){
      this.svg_mapa.selectAll("path.antiguo_lago")
        .attr("fill-opacity","0.3")
        .attr("fill","#fff")
        .attr("stroke","#fff")
        .attr("stroke-width","3px")

      this.svg_mapa.selectAll("path.actual_lago")
        .attr("fill-opacity",0)
        .attr("stroke-opacity",0)

      this.svg_mapa.select("path.zona_naicm")
        .attr("fill-opacity",0)
        .attr("stroke-opacity",0)

      this.svg_mapa.select("path.zona_federal")
        .attr("fill-opacity",0)
        .attr("stroke-opacity",0)

      this.svg_mapa.select("path.subcuenca")
        .attr("fill-opacity",0)
        .attr("stroke-opacity",0)
    },
    paso_2(){
      this.svg_mapa.selectAll("path.antiguo_lago")
        .attr("stroke-width","1px")
        .attr("fill","#05DBF2")
        .attr("stroke","#fff")
        .attr("fill-opacity","0.6")
        .attr("stroke-opacity","1")

      this.svg_mapa.selectAll("path.actual_lago")
        .attr("fill-opacity",0)
        .attr("stroke-opacity",0)
        

      this.svg_mapa.select("path.zona_naicm")
        .attr("fill-opacity",0)

      this.svg_mapa.select("path.zona_federal")
        .attr("fill-opacity",0)

      this.svg_mapa.select("path.subcuenca")
        .attr("fill-opacity",0)

    },
    paso_3(){
      this.svg_mapa.selectAll("path.antiguo_lago")
        .attr("stroke-width","1px")
        .attr("stroke","#fff")
        .attr("fill-opacity",".7")
        .attr("fill","#000")
        .attr("stroke-opacity","1")

      this.svg_mapa.selectAll("path.actual_lago")
        .attr("stroke-width","1px")
        .attr("fill-opacity",".85")
        .attr("stroke-opacity","1")
        .attr("fill","#05DBF2")
        .attr("stroke","#05DBF2")
      this.svg_mapa.select("path.ex_aicm")
        .attr("fill-opacity",0)
        .attr("stroke-opacity","0")

      this.svg_mapa.select("path.zona_naicm")
        .attr("fill-opacity",0)
        .attr("stroke-opacity","0")

      this.svg_mapa.select("path.zona_federal")
        .attr("fill-opacity",0)

      this.svg_mapa.select("path.subcuenca")
        .attr("fill-opacity",0)

    },
    paso_4(){
      this.svg_mapa.selectAll("path.antiguo_lago")
        .attr("fill-opacity", 0)
        .attr("stroke-opacity", 0)
      this.svg_mapa.select("path.ex_aicm")
        .attr("fill-opacity",".5")
        .attr("stroke-width","2")
        .attr("stroke-opacity","1")
        .attr("stroke","#000")
      this.svg_mapa.select("path.zona_naicm")
        .attr("fill-opacity",.4)
        .attr("stroke-width","2")
        .attr("stroke-opacity","1")


      this.svg_mapa.select("path.zona_federal")
        .attr("fill-opacity",0)
        .attr("stroke-width","0")
        
  
      this.svg_mapa.select("path.subcuenca")

        .attr("stroke-opacity","0")
        .attr("fill-opacity",".0")

    },
    paso_5(){
      this.svg_mapa.select("path.zona_federal")
        .attr("stroke-width","2")
        .attr("stroke-opacity","1")
        .attr("fill-opacity",.5)

      this.svg_mapa.select("path.subcuenca")
        .attr("stroke-opacity","0")
        .attr("fill-opacity",".0")
    },
    paso_6(){
      this.svg_mapa.select("path.ex_aicm")
        .attr("stroke-width","1px")

      this.svg_mapa.select("path.zona_federal")

        .attr("stroke-width","2")

      this.svg_mapa.select("path.zona_naicm")
        .attr("stroke-width","2")

      this.svg_mapa.select("path.subcuenca")
        .attr("stroke","#000")
        .attr("stroke-opacity","1")
        .attr("stroke-width","2.5")
        .attr("fill-opacity",".6")
    
      
    },

      
  }
};
</script>

<style scoped lang="scss">
@import "~leaflet/dist/leaflet.css";
  div.contenedor-mapa{
    width:100%;
    height:100vh;
    background-color:#5d5d5d;
  }
</style>

<style lang="scss">
  .leaflet-control-attribution.leaflet-control{
    z-index: 405;
    *,a,strong{
      font-size: 12px;
    }

    strong{
      font-weight: 600;
      color: #0078A8;
      a{
        color:inherit;
        font-weight: inherit;
      }
    }
    
  }
</style>
